import {
  CalendarDays,
  Compass,
  Dumbbell,
  Info,
  Lock,
  Plane,
  Shield,
  Trophy,
  UserCircle2
} from 'lucide-react';

const PROFILE_ITEMS = [
  { key: 'profile', label: '我的個人資料', path: '/profile', icon: UserCircle2 },
  { key: 'travel-profile', label: '我的旅伴檔案', path: '/travel/profile', icon: Compass }
];

const RECORD_ITEMS = [
  { key: 'events', label: '我的活動', path: '/my-events', icon: CalendarDays },
  { key: 'sports', label: '我的運動', path: '/my-sports', icon: Dumbbell },
  { key: 'travel', label: '我的旅行', path: '/my-travel', icon: Plane },
  { key: 'badges', label: '成就與勳章', path: '/levels-badges', icon: Trophy }
];

const ACCOUNT_ITEMS = [
  { key: 'security', label: '帳號安全', path: '/account-security', icon: Lock },
  { key: 'about-joinu', label: '關於 JoinU', path: '/about-joinu', icon: Info }
];

const ADMIN_ITEM = { key: 'admin', label: '管理後台', path: '/admin', icon: Shield };

export const getMemberCenterNavSections = (isAdmin = false) => [
  { label: '我的資料', items: PROFILE_ITEMS },
  { label: '我的紀錄', items: RECORD_ITEMS },
  {
    label: '帳號與支援',
    items: [ACCOUNT_ITEMS[0], ...(isAdmin ? [ADMIN_ITEM] : []), ACCOUNT_ITEMS[1]]
  }
];

// Kept as a non-admin snapshot for simple consumers and backwards compatibility.
export const MEMBER_CENTER_NAV_SECTIONS = getMemberCenterNavSections(false);

export const MOBILE_MEMBER_MENU_ITEMS = MEMBER_CENTER_NAV_SECTIONS.flatMap(section => section.items);

export const TOP_USER_MENU_SECTIONS = [
  { key: 'profiles', items: PROFILE_ITEMS },
  { key: 'records', items: RECORD_ITEMS },
  { key: 'account', items: [ACCOUNT_ITEMS[0]] }
];

export const TOP_USER_MENU_ITEMS = TOP_USER_MENU_SECTIONS.flatMap(section => section.items);

export const getTopUserMenuItems = () => TOP_USER_MENU_ITEMS;

export const MEMBER_ROUTE_PATHS = [
  '/profile',
  '/travel/profile',
  '/my-events',
  '/my-sports',
  '/my-travel',
  '/notifications',
  '/levels-badges',
  '/account-security',
  '/about-joinu',
  '/my',
  '/admin'
];

export const isMemberRoute = pathname => MEMBER_ROUTE_PATHS.some(path => (
  pathname === path || pathname.startsWith(`${path}/`)
));
